<style lang="stylus">
    .collect-modal
        position absolute
        right 24px
        bottom 24px
        z-index 100
        width 304px
        padding 0 24px 24px 24px
        box-shadow: 0px 15px 30px 0px rgba(0, 0, 0, 0.15);
        background #fff
        border-radius 8px
        &:after
            content ""
            position absolute
            left 0
            top 0
            width 100%
            height 100%
            border 1px solid rgba(0, 0, 0, 0.05)
            pointer-events none
            border-radius 8px
        .titlebox
            height 40px
            margin-bottom 8px
            p
                font-size 14px
                color #000
                font-weight 700
                line-height 40px
            .title-icon
                color #222
                position absolute
                top 8px
                right 8px
                width 24px
                height 24px
                cursor pointer
                border-radius 6px
                &:hover
                    background rgba(0, 0, 0, 0.06)
                >svg
                    position absolute
                    top 50%
                    left 50%
                    transform translate(-50%, -50%)
                    stroke $modal-title-textcolor
                    width 16px
                    height 16px
        .content
            font-size 14px
            line-height 18px
            color #222
            margin-bottom 24px
        .downloadbtn
            display flex
            justify-content center
            align-items center
            width 100%
            height 28px
            border-radius 6px
            background #017fff
            cursor pointer
            &:hover
                background #0177f0
            span
                font-size 11px
                color #fff
</style>

<template>
    <div class="collect-modal">
        <div class="titlebox">
            <p>{{ $t("remind") }}</p>
            <div class="title-icon" @click="handleClose">
                <iconSymbol name="Del" />
            </div>
        </div>
        <p class="content" v-html="$t('content', { hotkey: hotkeyText })"></p>
        <div class="downloadbtn" @click="handleClose">
            <span>{{ $t("closeText", { num: num }) }}</span>
        </div>
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue, Watch } from "vue-property-decorator";
    import { isMac } from "@/public/utils/customVue";

    @Component
    export default class CollectTips extends Vue {
        num = 5;

        get hotkeyText() {
            if (!isMac && this.lang == "de") return "Strg+D";
            return isMac ? "⌘+D" : "Ctrl+D";
        }
        handleClose() {
            this.$emit("closeCollectModal");
        }
        count() {
            let timer = setInterval(() => {
                this.num -= 1;
                if (this.num == 0) {
                    this.handleClose();
                    clearInterval(timer);
                }
            }, 1000);
        }
        created() {}
        mounted() {
            this.count();
        }
    }
</script>
<i18n>
{
    "zh": {
        "remind": "提示",
        "content": "想要快速找到亿图图示网页版？<br />按下 {hotkey} 快捷键收藏网页吧~",
        "closeText": "关闭提示({num}S)"
    },
    "en": {
        "remind": "Reminder",
        "content": "Need to find EdrawMax Online quickly?<br /> Press {hotkey} to bookmark the website.",
        "closeText": "Close({num}S)"
    },
    "fr": {
        "remind": "Rappeler",
        "content": "Besoin de trouver rapidement EdrawMax Online ?<br /> Appuyez sur {hotkey} pour ajouter le site Web à vos favoris.",
        "closeText": "Fermer({num}S)"
    },
    "de": {
        "remind": "Hinweis",
        "content": "Möchtest du EdrawMax Online schnell finden? <br />Drücke {hotkey}, um die Website zu den Lesezeichen hinzuzufügen.",
        "closeText": "Schließen({num}S)"
    },
    "jp": {
        "remind": "通知",
        "content": "EdrawMax Onlineをすぐに見つける必要がありますか？<br />{hotkey}を押して、Webサイトをブックマークします。",
        "closeText": "閉じる({num}S)"
    },
    "es": {
        "remind": "Recordatorio",
        "content": "¿Quieres encontrar EdrawMax Online rápidamente? <br />Presiona {hotkey} para marcar el sitio web como favorito.",
        "closeText": "Cerrar({num}S)"
    },
    "pt": {
        "remind": "Alerta",
        "content": "Precisa encontrar EdrawMax Online rapidamente? <br />Pressione {hotkey} para marcar este site.",
        "closeText": "Fechar({num}S)"
    },
    "it": {
        "remind": "Promemoria",
        "content": "Devi trovare EdrawMax online velocemente? <br />Premi {hotkey} per aggiungere il sito web ai preferiti.",
        "closeText": "Chiudi({num}S)"
    }
}
</i18n>
